<template>
  <div class="tracklist-tracks">
    <div v-for="track in sortedTracks" :key="track.metadata.music[0].acrid" class="tracklist-tracks__item">
      <div class="tracklist-tracks__item-cell">
        {{ useFormatDate('time', useFormatDate('utc', track.metadata.timestamp_utc)) }}
      </div>
      <div class="tracklist-tracks__item-cell">
        {{ `${track.metadata.music[0].artists[0].name} -` }}
        {{ track.metadata.music[0].title }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { compareDesc } from 'date-fns'

const props = defineProps<{
  tracks: any[]
}>()

const sortedTracks = computed(() => {
  return props.tracks.sort((a: any, b: any) => {
    return compareDesc(a.metadata.timestamp_utc, b.metadata.timestamp_utc)
  })
})

</script>

<style lang="scss">
@use "~/assets/sass/tools";

.tracklist-tracks {
  &__item {
    display: grid;
    gap: 0 calc(var(--grid-gutter) / 2);
    padding: var(--space--s) 0;
    border-top: var(--border);
    grid-template-columns: min-content auto;

    &:last-child {
      border-bottom: var(--border);
    }
  }

  &__item-cell {
    display: flex;
    align-items: flex-start;
    font-variant-numeric: tabular-nums;
    @include tools.to(tools.$breakpoint--desktop) {
      padding-bottom: 0;
    }

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
      @include tools.to(tools.$breakpoint--desktop) {
        padding-top: 0;
        padding-left: 0;
      }
    }
  }
}
</style>
